export function enabledExperiment(specName: string) {
  if (typeof (window as any)?.wixTagManager?.getConfig !== 'function') {
    return false
  }
  return (
    (window as any)?.wixTagManager?.getConfig()?.experiments?.[specName] ===
    'true'
  )
}
